import { isArray } from '../shortcut'

export function toArr<T>(val?: T | T[]): T[] {
  return isArray(val) ? val : val !== undefined && val !== null ? [val] : []
}
